<template>
    <div v-if="trainerPosition" class="lr-root" :style="bgStyle">
        <div class="lr-content">
            <div class="lr-card transparent07--dark">
                <div class="lr-title">{{ $t('journey.leagueRegister.title') }}</div>
                <v-img
                    class="lr-img"
                    :src="require('@/assets/pic/web/registration_joy.png')"
                    contain
                />
                <div class="lr-text">
                    {{ $t('journey.leagueRegister.text1') }}
                </div>
                <div class="lr-text" v-html="$t('journey.leagueRegister.text2')"/>
                <v-btn
                    large
                    rounded
                    :loading="isLoading"
                    :disabled="isLoading"
                    color="black--text"
                    class="gold-btn btn-shadow lr-btn"
                    @click="gotToPrepareFight()"
                >
                    {{ $t('journey.leagueRegister.prepareButton') }}
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
    // Fork úvodní obrazovky ligy - stará LeagueRegister.vue zůstává
    // zmrazená/referenční za !flags.newUi. Viz claude/components/journey-oak-league.md.
    import {mapActions, mapGetters} from 'vuex';
    import * as journeyApi from '@/api/journeyApi';

    export default {
        name: 'LeagueRegisterNext',
        props: {
            trainerPosition: {type: Object, default: null},
        },
        computed: {
            ...mapGetters({
                isLoading: 'journey/isLoading',
            }),
            bgStyle() {
                return {backgroundImage: `url(${require('@/assets/pic/web/league_stadion.png')})`};
            },
        },
        created() {
            this.trainerInfoMessages(this.trainerPosition.trainer.id);
        },
        methods: {
            ...mapActions({
                positionPost: 'journey/positionPost',
                trainerInfoMessages: 'trainer/loadInfoMessages',
            }),
            gotToPrepareFight() {
                this.positionPost(journeyApi.goToPrepareFight(this.trainerPosition.id));
            },
        },
    }
</script>

<style scoped>
.lr-root {
    position: fixed;
    inset: 0;
    height: 100%;
    background-size: cover;
    background-position: center;
    overflow-y: auto;
}
.lr-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100%;
    /* bottom 54px = rezerva pro globální TeamBottomSheet - .lr-root je "position: fixed; inset: 0" */
    padding: 24px 16px 54px 16px;
    box-sizing: border-box;
}
.lr-card {
    width: 100%;
    max-width: 420px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 18px;
    padding: 20px 18px;
    text-align: center;
    box-shadow: 2px 3px 10px rgba(0,0,0,0.35);
    box-sizing: border-box;
}
.lr-title {
    font-size: 24px;
    font-weight: 800;
    /* explicitní barva, ne spoleh na dědění z .transparent07--dark - ta nemá doprovodné `> *` pravidlo (schválně, kvůli v-btn pod ní) */
    color: #fff;
    margin-bottom: 8px;
}
.lr-img {
    max-width: 260px;
    margin-bottom: 8px;
}
.lr-text {
    font-size: 16px;
    color: #fff;
    margin-bottom: 10px;
}
.lr-btn {
    margin-top: 8px;
    min-height: 48px;
}
</style>
